import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handleAddCalendarDates } from "./CalendarsUtils/handleAddCalendarDates";
import { AddEventDialog } from "./AddEventDialog";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";

export const AddDateDialog = ({
  addDateDialogOpen,
  setAddDateDialogOpen,
  setCalendarEvents,
  calendarId,
  setShowMoreDialogOpen,
  setEditingCalendar,
  navigate,
}: {
  addDateDialogOpen: boolean;
  setAddDateDialogOpen: Dispatcher<boolean>;
  setCalendarEvents: any;
  calendarId: any;
  setShowMoreDialogOpen: Dispatcher<boolean>;
  setEditingCalendar: Dispatcher<boolean>;
  navigate: NavigateFunction;
}) => {
  const { isFeatureEnabled } = useFeatureFlag();
  const showAddCalendarScheduleTime = isFeatureEnabled(
    "showAddCalendarScheduleTime",
    false
  );

  return (
    <AddEventDialog
      open={addDateDialogOpen}
      title="Add Date"
      submitLabel="Save"
      showScheduleTime={showAddCalendarScheduleTime}
      onCancel={() => {
        setAddDateDialogOpen(false);
        setShowMoreDialogOpen(true);
      }}
      onSubmit={(newEvent) => {
        setEditingCalendar(true);
        handleAddCalendarDates(
          {
            calendar: calendarId,
            ...newEvent,
          },
          setCalendarEvents,
          setEditingCalendar,
          navigate
        );
        setAddDateDialogOpen(false);
        setShowMoreDialogOpen(true);
      }}
    />
  );
};
